import { render, staticRenderFns } from "./leftdayDiscount.vue?vue&type=template&id=45522fc8&"
import script from "./leftdayDiscount.vue?vue&type=script&lang=js&"
export * from "./leftdayDiscount.vue?vue&type=script&lang=js&"
import style0 from "./leftdayDiscount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports